import React from "react";
import { Button, Form, InputField } from "components/form";

import ChangePasswordImg from "assets/images/svg/security_and_login_change_password.svg";
import Info from "assets/images/svg/info_dark.svg";
import { useModal } from "hooks";
import ResetPasswordDialog from "pages/security-login/components/reset-password.dialog";
import { passwordPattern } from "helpers/patterns";
import { useTranslation } from "react-i18next";
import {client} from "helpers/client";
import {useAuthContext} from "store/auth";
import {toast} from "react-toastify";
import {useStatus} from "hooks/use-status";

const ChangePasswordPage = () => {
  const { t } = useTranslation('security');
  const [{user},dispatch] = useAuthContext();
  const {isLoading,load,stop,done} = useStatus();
  const [showRestPassword, openRestPassword, closeRestPassword] = useModal(false);

  async function handleResetPassword(data:any) {
      load();
      const resetPasswordDto = {
          "customerId": user.Id,
          "password": data.newPassword,
          "currentPassword": data.oldPassword
      }
      const {response} = await client('/security/resetPassword',{data:resetPasswordDto})
      if(response) {
          done();
          dispatch({type:"logout"});
          toast.success('changed successfully');
      }
      else stop()
  }

  return (
    <div className="changePasswordPage">
      <div className="row">
        <Form onSubmit={handleResetPassword} className="col-lg-4 col-md-6">
          {({ watch }) => {
            return (
              <>
                <InputField
                  id="oldPassword"
                  type="password"
                  label={t('current-password')}
                  rules={{ required: "errors:required" }}
                />
                <InputField
                  id="newPassword"
                  type="password"
                  label={t('new-password')}
                  warning={t("accountinfo:textwrning")}
                  rules={{
                    required: "errors:required",
                    pattern: {
                      value: passwordPattern,
                      message: "errors:password",
                    },
                  }}
                />
                <InputField
                  id="confirmPassword"
                  type="password"
                  label={t('confirm-new-password')}
                  rules={{
                    required: "errors:required",
                    pattern: {
                      value: new RegExp(`^${watch("newPassword")}$`),
                      message: "errors:passwordMismatch",
                    },
                  }}
                />
                <Button isLoading={isLoading} className="btn-blue">{t('change-password')}</Button>
                <div className="info">
                  <img src={Info} alt="info" />
                  <p>
                      {t('cant-remember-current-password')}
                    <span className="span-link" onClick={openRestPassword}>
                      {t('reset-your-password')}
                    </span>
                  </p>
                </div>
              </>
            );
          }}
        </Form>
        <div className="col-lg-8 col-md-6">
          <img
            className="img-fluid background"
            src={ChangePasswordImg}
            alt="ChangePasswordImg"
          />
        </div>
      </div>
      <ResetPasswordDialog show={showRestPassword} onHide={closeRestPassword} />
    </div>
  );
};

export default ChangePasswordPage;
